import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

// REVIEW_APPEASEMENT task attempts record which appeasement triggered the
// attempt. The mutation itself (approve / reject / abandon) is performed by
// AppeasementService; the attempt row exists for audit only.
export const ReviewAppeasementTaskAttemptSchema = z.object({
  type: z.literal(TaskType.REVIEW_APPEASEMENT),
  appeasementId: z.string().min(1),
});
